import * as React from "react";

import ManageMarket from "../ManageMarket";

const MarketsPanel: React.FC = () => {
	return <ManageMarket />;
};

export default MarketsPanel;
